import React, { useEffect } from 'react';
import { Button, Typography, Box, Tooltip } from '@mui/material';
import FlagIcon from '@mui/icons-material/Flag';
import InfoIcon from '@mui/icons-material/Info';
import './ActionCandidater.css';

const ActionCandidater = ({ mission, candidatures = [], onClick, hideButton = false }) => {
  const places = mission?.placesDispo || 0;
  const candidats = candidatures?.length || 0;
  const statut = mission?.status?.toLowerCase();
  const candidaturesRecruté = candidatures?.filter(c => c.statut === 'Recrutement confirmé').length || 0;

  const isDisabled = statut === 'recruté' || statut === 'inactive' || candidaturesRecruté === places;

  useEffect(() => {
    const shouldDisable = statut === 'active' && candidaturesRecruté === places;

    if (shouldDisable) {
      const updateStatus = async () => {
        try {
          const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/missions/${mission._id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...mission, status: 'inactive' })
          });

          if (!res.ok) {
            console.error('Erreur lors de la désactivation automatique de la mission');
          } else {
            console.log('Mission désactivée automatiquement');
          }
        } catch (err) {
          console.error('Erreur serveur :', err);
        }
      };

      updateStatus();
    }
  }, [statut, candidaturesRecruté, places, mission]);

  return (
    <Box className="action-candidater-container">
      <Typography variant="caption" className="action-candidater-info">
        <Tooltip title="Nombre de profils à pourvoir pour cette mission">
          <InfoIcon fontSize="small" className="info-icon" />
        </Tooltip>
        {` Profil(s) recherché(s) : ${places} `}
      </Typography>

      <Typography variant="caption" className="action-candidater-info">
        {`Candidat(s) proposé(s) : ${candidats}`}
      </Typography>

      {!hideButton && (
        <Button
          variant="contained"
          fullWidth
          startIcon={<FlagIcon />}
          disabled={isDisabled}
          onClick={onClick}
          className="action-candidater-btn"
        >
          Proposer un talent
        </Button>
      )}
    </Box>
  );
};

export default ActionCandidater;
